<template>
    <div>
        <div class="columns toolbar-box action-right">
            <div class="column is-12">
                <h1 class="title is-3 between-center">
                    <span ref="title" class="contenteditable">{{ copy.id ? 'Edit' : 'Create' }} Change Order</span>
                </h1>
                <h2 class="subtitle">Project: <router-link
                        :to="{ name: 'projects.show', params: { slug: item.project_id } }">{{
                            projectNameById(item.project_id) }}</router-link></h2>
            </div>
            <div class="column is-12 action-box">
                <div class="field is-grouped is-grouped-right is-flex-wrap">
                    <p class="control">
                        <router-link :to="{ name: 'projects.show.change-orders', params: { slug: item.project_id } }"
                            class="button is-default">Back</router-link>
                    </p>
                </div>
            </div>
        </div>
        <o-tabs v-model="tabIndex" type="is-boxed">
            <o-tab-item :value="0" label="Select Property">
                <form class="is-clearfix">
                    <div class="columns">
                        <div class="column">
                            <div class="between-center">
                                <o-field label="Company" style="flex: 1">
                                    <template #label>
                                        Company <span style="color: red">*</span>
                                    </template>
                                    <autocomplete-select type="company" placeholder="Select a Companies" track="id"
                                        field-name="name" v-model="copy.company_id"
                                        :value="companyById(item.company_id)" :error="getError('company_id')"
                                        @input="fetchCompanyContacts" />
                                </o-field>

                                <div class="field" style="margin: 20px 0 0 10px">
                                    <a @click="isCompanyModalActive = true" style="width: 170px"
                                        class="button is-primary">Add Company</a>
                                </div>
                            </div>

                            <div class="between-center">
                                <o-field label="Contacts" style="flex: 1" :type="fieldType('contacts')"
                                    :message="getError('contacts')">
                                    <template #label>
                                        Contacts <span style="color: red">*</span>
                                    </template>
                                    <multicomplete :disabled="loadingContacts" field-name="full_name" track="id"
                                        v-model="copy.contacts" :value="contacts" type="company_contacts"
                                        placeholder="Contact" @update:modelValue="handleContactSelected"
                                        :options-prop2="copy.company_id" />
                                </o-field>
                                <div class="field" style="margin: 15px 0 0 10px">
                                    <button @click.prevent="openNewContactModal(copy.company_id, 'contact_id')"
                                        :disabled="!copy.company_id" style="width: 170px" class="button is-primary">
                                        Add Contact
                                    </button>
                                </div>
                            </div>

                            <o-field label="Project" :error="getError('project_id')">
                                <template #label>
                                    Project <span style="color: red">*</span>
                                </template>
                                <autocomplete-select type="project" placeholder="Select a project" track="id"
                                    field-name="full_name" v-model="copy.project_id"
                                    :value="projectById(copy.project_id)" :disabled="!!copy.id" />
                            </o-field>

                            <o-field label="Deposit %" :type="fieldType('deposit_percent')"
                                :message="getError('deposit_percent')">
                                <o-input v-model="copy.deposit_percent" :disabled="copy.pay_in_full" />
                            </o-field>

                            <div class="field">
                                <o-checkbox v-model="copy.non_billable">Non Billable</o-checkbox>
                            </div>

                            <div class="field">
                                <o-checkbox v-model="copy.pay_in_full">Pay In Full</o-checkbox>
                            </div>

                            <o-field label="Terms and Conditions">
                                <template #label>
                                    Terms and Conditions <span style="color: red">*</span>
                                </template>
                                <quill-editor :content="copy.terms_and_conditions" :content-type="'html'"
                                    @change="copy.terms_and_conditions = $event" />
                            </o-field>
                            <p class="help is-info">[retainer_amount] will be replaced with Grand Total * Deposit
                                Percent</p>
                        </div>

                        <div class="column">
                            <o-field label="Date Created">
                                <template #label>
                                    Date Created <span style="color: red">*</span>
                                </template>
                                <o-input disabled :model-value="created_at" />
                            </o-field>

                            <o-field label="Floor Number">
                                <o-input v-model="copy.floor_number" />
                            </o-field>

                            <o-field label="Status" :type="fieldType('status')" :error="getError('status')">
                                <template #label>
                                    Status <span style="color: red">*</span>
                                </template>
                                <o-input :value="getChangeOrderStatus(copy)" disabled />
                            </o-field>

                            <o-field label="Approval Deadline" :type="fieldType('approval_deadline')"
                                :error="getError('approval_deadline')">
                                <datepicker placeholder="Select a date" :error="getError('approval_deadline')"
                                    v-model="copy.approval_deadline" />
                            </o-field>

                            <o-field label="Description" :type="fieldType('notes')" :error="getError('notes')">
                                <template #label>
                                    Description <span style="color: red">*</span>
                                </template>
                                <o-input type="textarea" v-model="copy.notes" />
                            </o-field>

                            <o-field label="Remind By" :type="fieldType('remind_by')" :error="getError('remind_by')">
                                <datepicker :config="config" placeholder="Select a date" :error="getError('remind_by')"
                                    v-model="copy.remind_by" />
                            </o-field>

                            <div class="block">
                                <input type="hidden" role="uploadcare-uploader" data-multiple="true" name="my_file" />
                            </div>
                        </div>
                    </div>

                    <div class="field is-grouped is-pulled-right">
                        <p class="control">
                            <router-link
                                :to="{ name: 'projects.show.change-orders', params: { slug: item.project_id } }"
                                class="button">Cancel</router-link>
                        </p>
                        <p class="control">
                            <button @click.prevent="goToTab(1)" class="button is-primary">Continue</button>
                        </p>
                        <p class="control">
                            <button @click.prevent="handleCreateOrUpdate" class="button is-success">Save</button>
                        </p>
                        <p class="control">
                            <button @click.prevent="handleSaveAndPreview" class="button is-success">Save &
                                Preview</button>
                        </p>
                    </div>

                    <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep"
                        v-model:active="isCompanyModalActive" has-modal-card>
                        <company-modal @company-added="selectCompany" />
                    </o-modal>

                    <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep"
                        v-model:active="isContactModalActive" has-modal-card>
                        <contact-modal @contact-added="selectContact" :item="{ company_id: newContactCompanyId }"
                            :quick-add="true" />
                    </o-modal>
                </form>
            </o-tab-item>

            <o-tab-item :value="1" label="Initial Services">
                <project-services-initial v-if="dictionariesLoaded" :source-id="changeOrderId"
                    source-type="change-order" :secondary-tab-index="secondaryTabIndex"
                    @secondary-tab-changed="secondaryTabIndex = $event" v-model="selectedServicesContainSubServices" />

                <div class="field is-grouped is-pulled-right">
                    <p class="control">
                        <router-link :to="{ name: 'projects.show.change-orders', params: { slug: item.project_id } }"
                            class="button">Cancel</router-link>
                    </p>
                    <p class="control">
                        <button @click.prevent="goToTab(0)" class="button is-dark">Back</button>
                    </p>
                    <p class="control">
                        <button @click.prevent="goToTab(2)" class="button is-primary">Continue</button>
                    </p>
                    <p class="control">
                        <button @click.prevent="handleCreateOrUpdate" class="button is-success">Save</button>
                    </p>
                    <p class="control">
                        <button @click.prevent="handleSaveAndPreview" class="button is-success">Save & Preview</button>
                    </p>
                </div>
            </o-tab-item>

            <o-tab-item :value="2" label="Pricing/Quantities">
                <pricing v-if="dictionariesLoaded" ref="pricing" :source-id="changeOrderId" />

                <div class="field is-grouped is-pulled-right">
                    <p class="control">
                        <router-link :to="{ name: 'projects.show.change-orders', params: { slug: item.project_id } }"
                            class="button">Cancel</router-link>
                    </p>
                    <p class="control">
                        <button @click.prevent="goToTab(1)" class="button is-dark">Back</button>
                    </p>
                    <p class="control">
                        <button @click.prevent="handleCreateOrUpdate" class="button is-success">Save</button>
                    </p>
                    <p class="control">
                        <button @click.prevent="handleSaveAndPreview" class="button is-success">Save & Preview</button>
                    </p>
                </div>
            </o-tab-item>
        </o-tabs>
        <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isPdfPreviewActive"
            has-modal-card :width="960" @close="previewModalCloseHandler">
            <preview-modal :action-button="actionButton" :file="currentPreviewFile" />
        </o-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Datepicker from './../../components/Datepicker'
import HandlesForm from './../../mixins/HandlesForm'

import CompanyModal from './../../components/modals/Company.vue'
import ContactModal from './../../components/modals/Contact.vue'

import { QuillEditor } from "@vueup/vue-quill"
import ProjectServicesInitial from '../../components/ProjectServicesInitial'
import PreviewModal from './../../components/modals/Preview'
import { getChangeOrderStatus } from './../../store/modules/change-orders/utils'
import Pricing from './form/PricingQuantities.vue'

export default {
    mixins: [HandlesForm],

    components: {
        QuillEditor,
        Datepicker,
        CompanyModal,
        ContactModal,
        PreviewModal,
        Pricing,
        ProjectServicesInitial,
    },

    mounted() {
        this.copy.created_by = this.currentUserId

        this.fetchCompanyContacts()
        this.setContacts(this.item.contacts)

        if (this.item.project_id && !this.copy.contact_id) {
            const project = this.projectById(this.item.project_id)
            this.fetchContactById(project.contact_id).then(() => this.selectContact(project.contact_id))
        }

        this.fetchCompanies({ id: this.item.company_id })

        //Muestra la informacion the contacts cuando se crean un Change Order
        if (!this.item.hasOwnProperty('id')) {
            this.fetchContactById(this.copy.contact_id)
                .then(value => {
                    this.contacts.push(value.data.data)
                })
        }

    },

    computed: {
        ...mapGetters([
            'contactById',
            'currentUserId',
            'contactsByCompanyId',
            'dictionariesLoaded',
            'projectInitialServicesBySource',
            'serviceById',
            'changeOrderStatuses',
            'projectServicesWhere',
            'projectById',
            'projectNameById',
            'companyById',
        ]),

        actionButton() {
            const vm = this
            if (!!vm.copy.sent_at) { return null }
            return {
                label: 'Send to customer',
                handler() {
                    const context = (!!vm.copy.is_negative ? 'negative-' : '') + 'change-order-message'
                    vm.openMessageModal({ entity: vm.copy, entity_type: 'change-order', context })
                    vm.$router.push(`/projects/${vm.copy.project_id}/change-orders`)
                }
            }
        },

        changeOrderId() {
            return this.item.id ? this.item.id : null
        },

        created_at() {
            let date = this.copy.created_at ? moment(this.copy.created_at) : moment()
            return date.format('MM/DD/YYYY')
        },
    },

    data() {
        return {
            contacts: [],
            currentPreviewFile: null,
            loadingContacts: false,
            tabIndex: 0,
            secondaryTabIndex: 0,

            selectedServicesContainSubServices: false,

            newContactCompanyId: null,

            isCompanyModalActive: false,
            isContactModalActive: false,
            isPdfPreviewActive: false,
            isReminderModalActive: false,
            config: {
                minDate: 'today'
            },
        }
    },

    beforeUnmount() {
        this.clearProjectServices()
    },

    methods: {
        ...mapActions(['clearProjectServices', 'fetchContactById', 'fetchCompanies', 'fetchProjectById', 'createOrUpdateChangeOrder', 'clearProjectServices', 'fetchContacts', 'fetchContactById', 'openMessageModal', 'processProjectService']),

        getChangeOrderStatus,

        handleContactSelected(data) {
            this.setContacts(data)
        },

        handleCreateOrUpdate(redirectBack = true) {
            let itemExists = this.copy.id !== undefined
            let submit = this.wrapSubmit(this.createOrUpdateChangeOrder)
            let projectServices = this.projectInitialServicesBySource({
                source_type: 'change-order',
                source_id: this.changeOrderId
            })

            for (let index in projectServices) {
                let projectService = projectServices[index]
                let service = this.serviceById(projectService.service_id)

                if (service.work_types && service.work_types.length && projectService.work_types && !projectService.work_types.length) {
                    this.errorMessage('Please pick Sub Services')
                    this.tabIndex = 1

                    return new Promise((_resolve, reject) => {
                        reject()
                    })
                }
            }

            let pricing = this.$refs.pricing

            if (!pricing.validateProjectServices()) {
                return new Promise((_resolve, reject) => {
                    this.errorMessage('Please verify project services listed price, work type price, title and notation are correct')
                    this.tabIndex = 3

                    reject()
                })
            }

            return submit(this.copy)
                .then(res => {
                    let id = res.data.data.id

                    itemExists ?
                        this.successMessage('Change Order has been updated') :
                        this.successMessage('Change Order has been created')

                    if (redirectBack) {
                        if (!!this.copy.is_negative && !this.copy.sent_at) {
                            const context = 'negative-change-order-message'
                            this.copy.id = id
                            this.openMessageModal({ entity: this.copy, entity_type: 'change-order', context })
                        }
                        this.$router.push(`/projects/${res.data.data.project_id}/change-orders`)
                    }

                    return res
                })
                .catch(res => {
                    this.tabIndex = 0
                    throw res
                })
        },

        handleSaveAndPreview() {
            this.handleCreateOrUpdate(false).then(res => {
                this.copy.id = res.data.data.id
                this.openPdfPreviewModal(res.data.data)
            })
        },

        goToTab(tabIndex) {
            if (this.tabIndex === 2 && tabIndex === 1 && this.selectedServicesContainSubServices) {
                this.secondaryTabIndex = 1
                this.tabIndex = tabIndex
            } else if (this.secondaryTabIndex === 0 && tabIndex === 2 && this.selectedServicesContainSubServices) {
                this.secondaryTabIndex = 1
            } else if (this.secondaryTabIndex === 1 && this.tabIndex === 2) {
                this.secondaryTabIndex = 0
            } else if (tabIndex === 0 && this.secondaryTabIndex === 1) {
                this.secondaryTabIndex = 0
            } else {
                this.secondaryTabIndex = 0
                this.tabIndex = tabIndex
            }

            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        },

        fetchCompanyContacts() {
            if (this.copy.company_id) {
                this.loadingContacts = true
                this.fetchContacts({ company_id: this.copy.company_id }).then().catch().finally(() => this.loadingContacts = false)
            }
        },

        openNewContactModal(companyId) {
            this.newContactCompanyId = companyId
            this.isContactModalActive = true
        },

        openPdfPreviewModal(changeOrder) {
            const port = window.location.port ? `:${window.location.port}` : '';
            this.currentPreviewFile = {
                name: `Change Order #${changeOrder.number}`,
                mime: 'application/pdf',
                path: `${window.location.protocol}//${window.location.hostname}${port}/change-orders/${changeOrder.id}/pdf`,
                generatedOnTheFly: true
            }
            this.isPdfPreviewActive = true
        },

        previewModalCloseHandler() {
            this.$router.push(`/projects/${this.copy.project_id}/change-orders`)
        },

        selectCompany(companyId) {
            this.copy.company_id = companyId
        },

        selectContact(contactId) {
            if (this.contacts.some(c => c.id === contactId)) { return }
            const contact = this.contactById(contactId)
            if (!!contact) {
                const data = [...this.contacts, contact]
                this.setContacts(data)
            }
        },

        setContacts(data) {
            if (this.copy.contact_id && Array.isArray(data) && data.length === 0) {
                 this.copy.contact_id = null
                
            }
            
            if (data === undefined) return;
            this.contacts = []
            this.copy.contacts = []
            if (!Array.isArray(data) || data.length === 0) { return }
            this.contacts = [...data]
            this.copy.contacts = [...data]
            // if (!Array.isArray(data) || data.length > 1) {
            //     data.forEach(c => this.copy.contacts.push(c.id))
            // }

        }
    },

    watch: {
        'copy.contacts'(value) {
            if (this.copy.contacts.length === 1) {
                this.copy.contact_id = value[0]
            }
        },

        'contacts'(value) {
            if (this.contacts.length === 1) {
                this.copy.contact_id = value[0]
            }

        }
    }
}</script>
